import { ACFMediaFragment } from "@/fragments";
import { gql } from "@apollo/client";

const GetCoverStoryDetail = gql`
  ${ACFMediaFragment}
  query GetCoverStoryDetail($databaseId: ID!, $language: String = "en") {
    rhCoverStory(id: $databaseId, language: $language) {
      databaseId
      title
      gameData {
        gameNumber
        coverStoryDate
        audio
        albumFormatted {
          album
          artist
        }
        coverStoryAlbumImage
        coverStoryVinylShopLink
        artistFeature {
          image {
            ...ACFMedia
          }
          body {
            text
          }
          cta {
            linkType
            externalLink
            label
            page {
              node {
                uri
              }
            }
          }
        }
      }
    }
  }
`;

export default GetCoverStoryDetail;